
export const entityTypes = [
  {label: 'School', value: 'Site'},
  {label: 'Provider', value: 'Company'},
  {label: 'Season', value: 'Season'},
  {label: 'Student', value: 'Student'},
  {label: 'User', value: 'User'},
  {label: 'Enrollment', value: 'Enrollment'},
  {label: 'Activity', value: 'Course'},
  {label: 'Discount definition', value: 'DiscountDefinition'},
  {label: 'Contact', value: 'Contact'},
  {label: 'Instructor', value: 'Teacher'},
  {label: 'Activity days', value: 'CourseDay'},
  {label: 'Family', value: 'Family'},
  {label: 'Refund', value: 'Refund'},
]

export const allowedTypes = entityTypes.map(ht => ht.value);